import { ChangeEvent, FC } from 'react'
import styles from 'styles/components/form.module.scss'
import text from 'styles/utility/text.module.scss'
import { FlexRow } from 'components/Flex'
import { ImageCrop, TextInput, ToggleRoundButton } from 'components/Form'
import { FormLabel } from 'components/Label'
import { Spacer } from 'components/Utility'
import { ErrorDescription, SubDescription } from 'components/Typography'
import { isValidDomainSacri } from 'lib/validator'
import classNames from 'classnames'

type Props = {
  isAvailableOnApp: boolean
  isAvailableOnWeb: boolean
  webHostName: string
  webLogoImageUrl: string
  handleIsAvailableOnApp: () => void
  handleIsAvailableOnWeb: () => void
  handleWebHostName: (event: ChangeEvent<HTMLInputElement>) => void
  handleWebLogoImageUrl: (value: string) => void
  isDomainDisabled: boolean
  storeId: string
}

const ReleaseTargetForm: FC<Props> = (props) => {
  const {
    isAvailableOnApp,
    isAvailableOnWeb,
    webHostName,
    webLogoImageUrl,
    handleIsAvailableOnApp,
    handleIsAvailableOnWeb,
    handleWebHostName,
    handleWebLogoImageUrl,
    isDomainDisabled,
    storeId,
  } = props

  return (
    <div className={styles.releaseTarget__body}>
      <h2 className={styles.releaseTarget__header}>サービス公開先</h2>
      <div className={styles.releaseTarget__container}>
        <div className={styles.releaseTarget__label}>
          <p>アプリ</p>
          <ToggleRoundButton permission={'release_app'} toggle={handleIsAvailableOnApp} on={isAvailableOnApp} />
        </div>
      </div>
      <div className={styles.releaseTarget__container}>
        <div className={styles.releaseTarget__label}>
          <p>ブラウザ</p>
          <ToggleRoundButton
            permission={'release_web'}
            toggle={webHostName && webLogoImageUrl ? handleIsAvailableOnWeb : () => null}
            on={isAvailableOnWeb}
          />
        </div>
      </div>
      <h3 className={styles.releaseTarget__subHeader}>ブラウザの設定</h3>
      <SubDescription description="公開したあとドメインを変更することはできません。" />
      <Spacer size={12} />
      <FlexRow justifyContent={'between'} alignItems={'end'}>
        <TextInput
          disabled={isDomainDisabled}
          label={'ドメイン'}
          maxLength={32}
          onChange={handleWebHostName}
          placeholder={'xxx'}
          required={true}
          size={'small'}
          type={'text'}
          value={webHostName}
        />
        <Spacer size={8} />
        <p className={classNames(text.nowrap, text.font_bold)}>.sacri-store.jp</p>
      </FlexRow>
      <ErrorDescription isError={!isValidDomainSacri(webHostName)} error={'ドメインの仕様を満たしていません'} />
      <Spacer size={8} />
      <SubDescription
        description={
          '半角英数字の小文字及びハイフンのみ使用できます。またハイフンは先頭に置くことができません\nドメイン名は最大32文字までで設定してください。\n一度設定したドメインは変更できません。'
        }
      />
      <Spacer size={8} />
      <FormLabel label={'ロゴ画像'} required={true} />
      <Spacer size={8} />
      <ImageCrop
        folderPath={`stores/${storeId}/logo`}
        handleImageUrl={handleWebLogoImageUrl}
        imageSize={{ width: 100, height: 28 }}
        imageUrl={webLogoImageUrl}
      />
      <Spacer size={8} />
      <SubDescription description={'ロゴのサイズは100px×28pxで登録されます。'} />
    </div>
  )
}

export default ReleaseTargetForm
